import React from 'react'
import PropTypes from 'prop-types';
import RequiredSelect from '../elements/required-select'

const UserTitleSelector = ({model = '.title', label = 'Title', disabled}) => {
  const values = [
    {label: 'Mr', value: 'Mr.'},
    {label: 'Mrs', value: 'Mrs.'},
    {label: 'Miss', value: 'Miss.'},
    {label: 'Ms', value: 'Ms.'},
  ];

  return (
    <RequiredSelect model={model}
                    values={values}
                    label={label}
                    disabled={disabled}
                    controlId="userTitle"/>
  )
};

UserTitleSelector.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

UserTitleSelector.defaultProps = {
  model: '.title',
  label: 'Title',
  disabled: false
};

export default UserTitleSelector;



// WEBPACK FOOTER //
// ./src/components/common/form/user/user-title-selector.jsx